<template>
    <div>
    </div>
</template>
<script type="text/javascript">
    import {PcCookie, Key} from '../../http/cookie'
    import common from '@/api/common';

    export default {
        created() {
            var $rus = this.$router.history;
            // let redirect_url = window.location.href //当前url

            if ($rus["current"].fullPath.indexOf('backUrl') !== -1) {
                let backUrl = decodeURIComponent($rus["current"].query.backUrl);
                const redirectURLToken = PcCookie.get(Key.accessTokenKey)
                if (redirectURLToken) {
                    if (backUrl.indexOf('dm') != -1) {
                        this.saveBehavior(backUrl)
                    }
                    window.location.href = backUrl
                }
                // alert('无 redirectURLToken')
                setTimeout(() => {
                    //从本地存储里获取
                    const access_token = localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION_NOBEARER')
                    // alert('从本地存储里获取')
                    // alert(access_token)
                    if (access_token) {
                        // alert('有 redirectURLToken')
                        PcCookie.set(Key.accessTokenKey, access_token)
                        window.location.href = backUrl
                        // wx.closeWindow()
                    }
                }, 300)
            }
        },
        methods: {
            // 用户行为 判断去营销工具
            saveBehavior(backUrl) {
                let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'));

                if(!ADMIN.USER_CODE){
                    return
                }
                const parmas = {
                    behaviorType: '9',
                    module: '1',
                    objectType: '10',
                    objectCode: 'WX',
                    userCode: ADMIN.USER_CODE,
                }

                common.saveBehavior(parmas).then(res => {
                    window.location.href = backUrl
                })
            }
        }
    };
</script>
